import { __rest, __assign } from "./auth-service-tools519.js";
import * as React from "react";
import { fullWidthClassName, zeroRightClassName } from "./auth-service-tools998.js";
import { effectCar } from "./auth-service-tools999.js";
import { useMergeRefs } from "./auth-service-tools1000.js";

var nothing = function () {
  return;
};

var RemoveScroll = /*#__PURE__*/React.forwardRef(function (props, parentRef) {
  var ref = React.useRef(null);

  var _a = React.useState({
    onScrollCapture: nothing,
    onWheelCapture: nothing,
    onTouchMoveCapture: nothing
  }),
      callbacks = _a[0],
      setCallbacks = _a[1];

  var forwardProps = props.forwardProps,
      children = props.children,
      className = props.className,
      removeScrollBar = props.removeScrollBar,
      enabled = props.enabled,
      shards = props.shards,
      sideCar = props.sideCar,
      noIsolation = props.noIsolation,
      inert = props.inert,
      allowPinchZoom = props.allowPinchZoom,
      _b = props.as,
      Container = _b === void 0 ? "div" : _b,
      gapMode = props.gapMode,
      rest = __rest(props, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noIsolation", "inert", "allowPinchZoom", "as", "gapMode"]);

  var SideCar = sideCar;
  var containerRef = useMergeRefs([ref, parentRef]);

  var containerProps = __assign(__assign({}, rest), callbacks);

  return /*#__PURE__*/React.createElement(React.Fragment, null, enabled && /*#__PURE__*/React.createElement(SideCar, {
    sideCar: effectCar,
    removeScrollBar,
    shards,
    noIsolation,
    inert,
    setCallbacks,
    allowPinchZoom: !!allowPinchZoom,
    lockRef: ref,
    gapMode
  }), forwardProps ? /*#__PURE__*/React.cloneElement(React.Children.only(children), __assign(__assign({}, containerProps), {
    ref: containerRef
  })) : /*#__PURE__*/React.createElement(Container, __assign({}, containerProps, {
    className,
    ref: containerRef
  }), children));
});
RemoveScroll.defaultProps = {
  enabled: true,
  removeScrollBar: true,
  inert: false
};
RemoveScroll.classNames = {
  fullWidth: fullWidthClassName,
  zeroRight: zeroRightClassName
};
export { RemoveScroll };